import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  step?: string;
}

export const FeatureCard = ({ icon: Icon, title, description, step }: FeatureCardProps) => {
  return (
    <div className="group p-8 rounded-3xl border border-slate-100 bg-slate-50/50 hover:bg-white hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 relative overflow-hidden">
      
      {step && (
        <span className="absolute top-4 right-6 text-slate-100 font-black text-6xl group-hover:text-gold-primary/5 transition-colors">
          {step}
        </span>
      )}

      <div className="w-16 h-16 bg-white rounded-2xl shadow-sm flex items-center justify-center text-[#D4AF37] mb-8 group-hover:scale-110 group-hover:gold-gradient group-hover:text-white transition-all duration-300">
        <Icon size={28} strokeWidth={1.5} />
      </div>

      <div className="relative z-10">
        <h3 className="text-xl font-bold mb-4 text-slate-800 group-hover:text-[#B8860B] transition-colors">
          {title}
        </h3>
        <p className="text-slate-600 leading-relaxed">
          {description}
        </p>
      </div>

      <div className="absolute bottom-0 left-0 h-1 w-0 gold-gradient group-hover:w-full transition-all duration-500" />
    </div>
  );
};